



import { useState, useEffect } from "react";
import axios from "axios";
import { FaUsers, FaUserPlus } from "react-icons/fa";
import { IoMdSettings } from "react-icons/io";
import { FaEllipsisV } from "react-icons/fa";
import {
  showSuccess,
  showError,
} from "../../General/Toast";



  const Addstaff = ({ clientData }) => {
  const client_id = clientData?.id || "";

  const [showRoleModal, setShowRoleModal] = useState(false);
const [openMenu, setOpenMenu] = useState(null);
useEffect(() => {
  const handleOutsideClick = () => {
    setOpenMenu(null);
  };

  document.addEventListener("click", handleOutsideClick);

  return () => {
    document.removeEventListener("click", handleOutsideClick);
  };
}, []);
const [roleName, setRoleName] = useState("");
const [showNameModal, setShowNameModal] = useState(false);
const [showPasswordModal, setShowPasswordModal] = useState(false);
const [showRoleModalEdit, setShowRoleModalEdit] = useState(false);

const [selectedStaff, setSelectedStaff] = useState(null);

const [newName, setNewName] = useState("");
const [newPassword, setNewPassword] = useState("");
const [newRole, setNewRole] = useState("");
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [staffToDelete, setStaffToDelete] = useState(null);
const handleEditName = (staff) => {
  setSelectedStaff(staff);
  setNewName(staff.name);
  setShowNameModal(true);
  setOpenMenu(null);
};
const handleChangePassword = (staff) => {
  setSelectedStaff(staff);
  setNewPassword("");
  setShowPasswordModal(true);
  setOpenMenu(null);
};
const handleChangeRole = (staff) => {
  setSelectedStaff(staff);
  setNewRole(staff.role);
  setShowRoleModalEdit(true);
  setOpenMenu(null);
};

const [roles, setRoles] = useState([
  "Manager",
  "Biller",
  "Cashier",
]);
  const [showPartyForm, setShowPartyForm] = useState(false);
  const [staffList, setStaffList] = useState([]);
const [permissions, setPermissions] = useState({
  billing: false,
  overview: false,
  inventory: false,
  reports: false,
  addParty: false,
  expenses: false,
  barcode: false,
  addStaff: false,
  addBranches: false,
  onlineStore: false,
  premium: false,
  loyaltyPoints: false,
  addOffers: false,
  settings: false,
});
// useEffect(() => {
//   if (!clientData?.id) return;

//   const savedPermissions = localStorage.getItem(
//     `permissions_${clientData.id}`
//   );

//   if (savedPermissions) {
//     const parsedPermissions = JSON.parse(savedPermissions);

//     setPermissions(parsedPermissions);

//     const selectedActions = Object.keys(parsedPermissions).filter(
//       (key) => parsedPermissions[key]
//     );

//     setStaffData((prev) => ({
//       ...prev,
//       actions: selectedActions,
//     }));
//   }
// }, [clientData?.id]);

// const handleRemoveStaff = async (staff) => {
//   const confirmDelete = window.confirm(
//     `Remove ${staff.name}?`
//   );

//   if (!confirmDelete) return;

//   try {
//     const res = await axios.delete(
//       `https://api.dectwinbilling.com/delete-staff/${clientData.id}/${staff.number}`
//     );

//     alert(res.data.message);

//     fetchStaff();
//     setOpenMenu(null);
//   } catch (error) {
//     console.log(error);
   
//     showError("Failed to delete staff");;
//   }
// };
const fetchRoles = async () => {
  try {
    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-roles/${clientData.id}`
    );

    console.log("Roles:", res.data);

    const roleNames = res.data.map(
      (item) => item.cat_name
    );

    setRoles(roleNames);

  } catch (error) {
    console.log("Fetch roles error:", error);
  }
};

const handleRemoveStaff = (staff) => {
  setStaffToDelete(staff);
  setShowDeleteModal(true);
  setOpenMenu(null);
};
const confirmDeleteStaff = async () => {
  try {
    const res = await axios.delete(
      `https://api.dectwinbilling.com/delete-staff/${clientData.id}/${staffToDelete.number}`
    );

    showSuccess("Staff Deleted successfully");

    fetchStaff();

    setShowDeleteModal(false);
    setStaffToDelete(null);
  } catch (error) {
    console.log(error);
    showError("Failed to delete staff");
  }
};

const toggleStaffStatus = async (staff) => {
  try {
    const newStatus = staff.active === 1 ? 0 : 1;

    const response = await axios.put(
      `https://api.dectwinbilling.com/update-staff-status/${staff.client_id}`,
      {
        active: newStatus,
        number: staff.number,
      }
    );

    alert(response.data.message);

    await fetchStaff();

  } catch (error) {
    console.error("Error updating staff status:", error);

    alert(
      error.response?.data?.error ||
      "Failed to update staff status"
    );
  }
};
const handleSelectStaff = (staff) => {
  setSelectedStaff(staff);

  const actions = parseActions(staff.actions);

  const permissionState = {
    billing: actions.includes("billing"),
    overview: actions.includes("overview"),
    inventory: actions.includes("inventory"),
    reports: actions.includes("reports"),
    addParty: actions.includes("addParty"),
    expenses: actions.includes("expenses"),
    barcode: actions.includes("barcode"),
    addStaff: actions.includes("addStaff"),
    addBranches: actions.includes("addBranches"),
    onlineStore: actions.includes("onlineStore"),
    premium: actions.includes("premium"),
    loyaltyPoints: actions.includes("loyaltyPoints"),
    addOffers: actions.includes("addOffers"),
    settings: actions.includes("settings"),
  };

  setPermissions(permissionState);
};

// const handleSelectStaff = (staff) => {
//   setSelectedStaff(staff);

//   let actions = staff.actions || [];

//   // DB se string aa sakti hai
//   try {
//     while (typeof actions === "string") {
//       actions = JSON.parse(actions);
//     }
//   } catch (error) {
//     console.log("Permission actions parse error:", error);
//     actions = [];
//   }

//   if (!Array.isArray(actions)) {
//     actions = [];
//   }

//   const permissionState = {
//     billing: actions.includes("billing"),
//     overview: actions.includes("overview"),
//     inventory: actions.includes("inventory"),
//     reports: actions.includes("reports"),
//     addParty: actions.includes("addParty"),
//     expenses: actions.includes("expenses"),
//     barcode: actions.includes("barcode"),
//     addStaff: actions.includes("addStaff"),
//     addBranches: actions.includes("addBranches"),
//     onlineStore: actions.includes("onlineStore"),
//     premium: actions.includes("premium"),
//     loyaltyPoints: actions.includes("loyaltyPoints"),
//     addOffers: actions.includes("addOffers"),
//     settings: actions.includes("settings"),
//   };

//   setPermissions(permissionState);
// };
const handlePermissionChange = (e) => {
  const { name, checked } = e.target;

  setPermissions((prev) => ({
    ...prev,
    [name]: checked,
  }));
};
const handleApplyChanges = async () => {
  try {

    const staffToUpdate =
      selectedStaff || staffList?.[0];

    if (!staffToUpdate) {
      showError("Please select a staff first");
      return;
    }

    if (!staffToUpdate.id && !staffToUpdate.number) {
      showError("Selected staff information is missing");
      return;
    }

    const selectedActions = Object.keys(
      permissions
    ).filter(
      (key) => permissions[key] === true
    );

    const payload = {
      name: staffToUpdate.name || "",
      pass: staffToUpdate.pass || "",
      role: staffToUpdate.role || "",
      number: staffToUpdate.number || "",
      actions: selectedActions,
    };

    console.log(
      "Permission Update Payload:",
      payload
    );

    const res = await axios.put(
      `https://api.dectwinbilling.com/update-staff/${clientData.id}`,
      payload
    );

    showSuccess(
      res.data?.message ||
      "Permissions Updated Successfully"
    );

    const staffRes = await axios.get(
      `https://api.dectwinbilling.com/fetch-staff/${clientData.id}`
    );

    const updatedStaffList =
      staffRes.data || [];

    setStaffList(updatedStaffList);

    const updatedStaff =
      updatedStaffList.find(
        (staff) =>
          staff.id === staffToUpdate.id
      ) ||
      updatedStaffList.find(
        (staff) =>
          staff.number === staffToUpdate.number
      ) ||
      updatedStaffList[0];

    if (updatedStaff) {

      setSelectedStaff(updatedStaff);

      const updatedActions =
        parseActions(
          updatedStaff.actions
        );

      setPermissions({
        billing: updatedActions.includes("billing"),
        overview: updatedActions.includes("overview"),
        inventory: updatedActions.includes("inventory"),
        reports: updatedActions.includes("reports"),
        addParty: updatedActions.includes("addParty"),
        expenses: updatedActions.includes("expenses"),
        barcode: updatedActions.includes("barcode"),
        addStaff: updatedActions.includes("addStaff"),
        addBranches: updatedActions.includes("addBranches"),
        onlineStore: updatedActions.includes("onlineStore"),
        premium: updatedActions.includes("premium"),
        loyaltyPoints: updatedActions.includes("loyaltyPoints"),
        addOffers: updatedActions.includes("addOffers"),
        settings: updatedActions.includes("settings"),
      });
    }

  } catch (error) {

    console.error(
      "Permission update error:",
      error
    );

    showError(
      error.response?.data?.error ||
      error.response?.data?.message ||
      "Failed to save permissions"
    );
  }
};
// const handleApplyChanges = async () => {
//   if (!selectedStaff) {
//     showError("Please select a staff first");
//     return;
//   }

//   try {
//     const selectedActions = Object.keys(permissions).filter(
//       (key) => permissions[key]
//     );

//     const payload = {
//       name: selectedStaff.name,
//       pass: selectedStaff.pass,
//       role: selectedStaff.role,
//       number: selectedStaff.number,
//       actions: selectedActions,
//     };

//     console.log("Permission Update Payload:", payload);

//     const res = await axios.put(
//       `https://api.dectwinbilling.com/update-staff/${clientData.id}`,
//       payload
//     );

//     showSuccess(
//       res.data?.message || "Permissions Updated Successfully"
//     );

//     // DB se fresh staff data lao
//     const staffRes = await axios.get(
//       `https://api.dectwinbilling.com/fetch-staff/${clientData.id}`
//     );

//     const updatedStaffList = staffRes.data || [];

//     setStaffList(updatedStaffList);

//     // Updated selected staff find karo
//     const updatedStaff = updatedStaffList.find(
//       (staff) => staff.id === selectedStaff.id
//     );

//     if (updatedStaff) {
//       setSelectedStaff(updatedStaff);

//       const updatedActions = parseActions(updatedStaff.actions);

//       setPermissions({
//         billing: updatedActions.includes("billing"),
//         overview: updatedActions.includes("overview"),
//         inventory: updatedActions.includes("inventory"),
//         reports: updatedActions.includes("reports"),
//         addParty: updatedActions.includes("addParty"),
//         expenses: updatedActions.includes("expenses"),
//         barcode: updatedActions.includes("barcode"),
//         addStaff: updatedActions.includes("addStaff"),
//         addBranches: updatedActions.includes("addBranches"),
//         onlineStore: updatedActions.includes("onlineStore"),
//         premium: updatedActions.includes("premium"),
//         loyaltyPoints: updatedActions.includes("loyaltyPoints"),
//         addOffers: updatedActions.includes("addOffers"),
//         settings: updatedActions.includes("settings"),
//       });
//     }

//   } catch (error) {
//     console.error("Permission update error:", error);

//     showError(
//       error.response?.data?.error ||
//       error.response?.data?.message ||
//       "Failed to save permissions"
//     );
//   }
// };

// const handleApplyChanges = async () => {
//   if (!selectedStaff) {
//     showError("Please select a staff first");
//     return;
//   }

//   try {
//     const selectedActions = Object.keys(permissions).filter(
//       (key) => permissions[key] === true
//     );

//     let existingActions = selectedStaff.actions || [];

//     try {
//       while (typeof existingActions === "string") {
//         existingActions = JSON.parse(existingActions);
//       }
//     } catch (error) {
//       existingActions = [];
//     }

//     if (!Array.isArray(existingActions)) {
//       existingActions = [];
//     }

//     const payload = {
//       name: selectedStaff.name,
//       pass: selectedStaff.pass,
//       role: selectedStaff.role,
//       number: selectedStaff.number,
//       actions: selectedActions,
//     };

//     console.log("PERMISSION UPDATE PAYLOAD:", payload);

//     const res = await axios.put(
//       `https://api.dectwinbilling.com/update-staff/${clientData.id}`,
//       payload
//     );

//     showSuccess(
//       res.data?.message || "Permissions Applied Successfully"
//     );

//     await fetchStaff();

//     // selected staff ko updated actions ke saath refresh karo
//     setSelectedStaff({
//       ...selectedStaff,
//       actions: selectedActions,
//     });

//   } catch (error) {
//     console.error("Permission update error:", error);

//     showError(
//       error.response?.data?.error ||
//       error.response?.data?.message ||
//       "Failed to save permissions"
//     );
//   }
// };
// const handlePermissionChange = (e) => {
//   const { name, checked } = e.target;

//   const updatedPermissions = {
//     ...permissions,
//     [name]: checked,
//   };

//   setPermissions(updatedPermissions);

//   // localStorage me save
//   localStorage.setItem(
//     `permissions_${clientData.id}`,
//     JSON.stringify(updatedPermissions)
//   );

//   const selectedActions = Object.keys(updatedPermissions).filter(
//     (key) => updatedPermissions[key]
//   );

//   setStaffData((prev) => ({
//     ...prev,
//     actions: selectedActions,
//   }));
// };



// const handleRemoveStaff = async (id) => {
//   if (
//     !window.confirm(
//       "Are you sure you want to remove this staff?"
//     )
//   )
//     return;

//   try {
//     await axios.delete(
//       `https://api.dectwinbilling.com/delete_staff/${id}`
//     );

//     fetchStaff();
//   } catch (error) {
//     console.log(error);
//   }
// };
// const handleApplyChanges = () => {
//   const selectedActions = Object.keys(permissions).filter(
//     (key) => permissions[key]
//   );

//   setStaffData((prev) => ({
//     ...prev,
//     actions: selectedActions,
//   }));

// showSuccess("Permissions Applied Successfully");
// };
// const handleAddRole = () => {
//   if (!roleName.trim()) {
//     alert("Enter Role Name");
//     return;
//   }

//   if (roles.includes(roleName.trim())) {
//     alert("Role already exists");
//     return;
//   }


//   // setRoles((prev) => [...prev, roleName.trim()]);



//   setRoleName("");
//   setShowRoleModal(false);
// };


// const updateStaff = async () => {
//   try {
//     await axios.put(
//       `https://api.dectwinbilling.com/update-staff/${clientData.id}`,
//       {
//         name: newName || selectedStaff.name,
//         pass: newPassword || selectedStaff.pass,
//         role: newRole || selectedStaff.role,
//         number: selectedStaff.number,
//         actions: selectedStaff.actions || []
//       }
//     );

//    showSuccess("Staff Updated Successfully");

//     fetchStaff();

//     setShowNameModal(false);
//     setShowPasswordModal(false);
//     setShowRoleModalEdit(false);

//     setNewName("");
//     setNewPassword("");
//     setNewRole("");

//   } catch (error) {
//     console.log(error);
//     alert("Update failed");
//   }
// };
// {showNameModal && (
//   <div className="modal-overlay">
//     <div className="custom-modal">
//       <h3>Change Staff Name</h3>

//       <div className="mt-3">
//         <label>Enter Name :</label>

//         <input
//           type="text"
//           className="form-control"
//           value={newName}
//           onChange={(e) =>
//             setNewName(e.target.value)
//           }
//           placeholder="Enter Here"
//         />
//       </div>

//       <div className="d-flex justify-content-center gap-3 mt-4">
//         <button
//           className="btn btn-secondary"
//           onClick={() =>
//             setShowNameModal(false)
//           }
//         >
//           No
//         </button>

//         <button
//           className="btn btn-primary"
//           onClick={updateStaffName}
//         >
//           Yes
//         </button>
//       </div>
//     </div>
//   </div>
// )}
const handleAddRole = async () => {
  if (!roleName.trim()) {
       showError("Enter Role Name");
    return;
  }

  if (roles.includes(roleName.trim())) {
    showError("Role already exists");
    return;
  }

  try {
    const response = await axios.post("https://api.dectwinbilling.com/add-category", {
      cat_name: roleName.trim(),
      cat_type: "StaffRole",
      client_id:  clientData.id
    });

    console.log(response.data);

  


    showSuccess("Role Added Successfully");
    await fetchRoles();

    setRoleName("");
    setShowRoleModal(false);

  } catch (error) {
    console.log(error);

    alert(
      error.response?.data?.message || "Failed to add role"
    );
  }
};
const updateStaff = async (type) => {
  try {

    // ============================================
    // SAFETY CHECK
    // ============================================

    if (!selectedStaff) {
      showError("Please select a staff first");
      return;
    }

    if (!selectedStaff.id && !selectedStaff.number) {
      showError("Selected staff information is missing");
      return;
    }


    // ============================================
    // SAFE ACTIONS PARSE
    // ============================================

    let actionsData = selectedStaff.actions || [];

    try {
      while (typeof actionsData === "string") {
        actionsData = JSON.parse(actionsData);
      }
    } catch (error) {
      console.log("Actions parse error:", error);
      actionsData = [];
    }

    if (!Array.isArray(actionsData)) {
      actionsData = [];
    }


    // ============================================
    // VALIDATION
    // ============================================

    if (type === "name" && !newName.trim()) {
      showError("Please enter staff name");
      return;
    }

    if (type === "password" && !newPassword.trim()) {
      showError("Please enter new password");
      return;
    }

    if (type === "role" && !newRole.trim()) {
      showError("Please select a role");
      return;
    }


    // ============================================
    // PAYLOAD
    // ============================================

    const payload = {
      name:
        type === "name"
          ? newName.trim()
          : selectedStaff.name || "",

      pass:
        type === "password"
          ? newPassword
          : selectedStaff.pass || "",

      role:
        type === "role"
          ? newRole.trim()
          : selectedStaff.role || "",

      number:
        selectedStaff.number || "",

      actions: actionsData,
    };


    console.log("UPDATE STAFF PAYLOAD:", payload);


    // ============================================
    // API
    // ============================================

    const res = await axios.put(
      `https://api.dectwinbilling.com/update-staff/${clientData.id}`,
      payload
    );


    showSuccess(
      res.data?.message ||
      "Staff updated successfully"
    );


    // ============================================
    // REFRESH STAFF
    // ============================================

    await fetchStaff();


    // ============================================
    // CLOSE MODALS
    // ============================================

    setShowRoleModalEdit(false);
    setShowNameModal(false);
    setShowPasswordModal(false);

    setNewRole("");
    setNewName("");
    setNewPassword("");


  } catch (error) {

    console.error(
      "Update staff error:",
      error
    );

    showError(
      error.response?.data?.error ||
      error.response?.data?.message ||
      "Staff update failed"
    );
  }
};
// const updateStaff = async (type) => {
  
//   try {
//     const payload = {
//       name: type === "name" ? newName : selectedStaff.name,
//       pass: type === "password" ? newPassword : selectedStaff.pass,
//       role: type === "role" ? newRole : selectedStaff.role,
//       number: selectedStaff.number,
//       actions: selectedStaff.actions
//     };

//     console.log("UPDATE PAYLOAD:", payload);

//     const res = await axios.put(
//       `https://api.dectwinbilling.com/update-staff/${clientData.id}`,
//       payload
//     );

//     showSuccess(
//       res.data.message || "Staff updated successfully"
//     );

//     await fetchStaff();

//     setShowRoleModalEdit(false);
//     setShowNameModal(false);
//     setShowPasswordModal(false);

//     setNewRole("");
//     setNewName("");
//     setNewPassword("");
//     setSelectedStaff(null);

//   } catch (error) {
//     console.error("Update error:", error);

//     showError(
//       error.response?.data?.error ||
//       error.response?.data?.message ||
//       "Staff update failed"
//     );
//   }
// };
// const updateStaff = async (type) => {
//   try {
//     // const payload = {
//     //   name: newName || selectedStaff.name,
//     //   pass: newPassword || selectedStaff.pass,
//     //   role: newRole || selectedStaff.role,
//     //   number: selectedStaff.number,
//     //   actions: selectedStaff.actions || []
//     // };

//     // await axios.put(
//     //   `https://api.dectwinbilling.com/update-staff/${clientData.id}`,
//     //   payload
//     // );
//     const payload = {
//   name: selectedStaff.name || "",
//   pass: selectedStaff.pass || "",
//   role: newRole.trim(),
//   number: selectedStaff.number,
//   actions: selectedStaff.actions
// };

// console.log("Role Update Payload:", payload);

// await axios.put(
//   `https://api.dectwinbilling.com/update-staff/${clientData.id}`,
//   payload
// );

  
//     if (type === "name") {
//       showSuccess("Staff name updated successfully");
//     } 
//     else if (type === "password") {
//       showSuccess("Staff password updated successfully");
//     } 
//     else if (type === "role") {
//       showSuccess("Staff role updated successfully");
//     } 
//     else {
//       showSuccess("Staff updated successfully");
//     }

//     fetchStaff();

//     setShowNameModal(false);
//     setShowPasswordModal(false);
//     setShowRoleModalEdit(false);

//     setNewName("");
//     setNewPassword("");
//     setNewRole("");

//   } catch (error) {
//     console.log(error);
//     showError("Update failed");
//   }
// };
const [staffData, setStaffData] = useState({
  client_id: "",
  name: "",
  role: "",
  pass: "",
  number: "",
  active: "",
  actions: []
});

const handleChange = (e) => {
  const { name, value } = e.target;

  setStaffData((prev) => ({
    ...prev,
    [name]: value,
  }));
};
const fetchStaff = async () => {
  try {
    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-staff/${clientData.id}`
    );

    const data = res.data || [];

    setStaffList(data);

    // Automatically select first staff
    if (data.length > 0) {
      const staff = data[0];

      setSelectedStaff(staff);

      const actions = parseActions(staff.actions);

      setPermissions({
        billing: actions.includes("billing"),
        overview: actions.includes("overview"),
        inventory: actions.includes("inventory"),
        reports: actions.includes("reports"),
        addParty: actions.includes("addParty"),
        expenses: actions.includes("expenses"),
        barcode: actions.includes("barcode"),
        addStaff: actions.includes("addStaff"),
        addBranches: actions.includes("addBranches"),
        onlineStore: actions.includes("onlineStore"),
        premium: actions.includes("premium"),
        loyaltyPoints: actions.includes("loyaltyPoints"),
        addOffers: actions.includes("addOffers"),
        settings: actions.includes("settings"),
      });
    } else {
      setSelectedStaff(null);

      setPermissions({
        billing: false,
        overview: false,
        inventory: false,
        reports: false,
        addParty: false,
        expenses: false,
        barcode: false,
        addStaff: false,
        addBranches: false,
        onlineStore: false,
        premium: false,
        loyaltyPoints: false,
        addOffers: false,
        settings: false,
      });
    }

  } catch (error) {
    console.error("Fetch staff error:", error);
  }
};
// const fetchStaff = async () => {
//   try {
//     const res = await axios.get(
//       `https://api.dectwinbilling.com/fetch-staff/${clientData.id}`
//     );

//     const data = res.data || [];

//     setStaffList(data);

//   } catch (error) {
//     console.error("Fetch staff error:", error);
//   }
// };
const parseActions = (actions) => {
  if (!actions) return [];

  try {
    while (typeof actions === "string") {
      actions = JSON.parse(actions);
    }

    return Array.isArray(actions) ? actions : [];
  } catch (error) {
    console.error("Actions parse error:", error);
    return [];
  }
};


// const fetchStaff = async () => {
//   try {
//     const res = await axios.get(
//       `https://api.dectwinbilling.com/fetch-staff/${clientData.id}`
//     );

//     const staffData = res.data || [];

//     setStaffList(staffData);

//     if (staffData.length > 0 && !selectedStaff) {
//       const staff = staffData[0];

//       let actions = staff.actions || [];

//       try {
//         while (typeof actions === "string") {
//           actions = JSON.parse(actions);
//         }
//       } catch {
//         actions = [];
//       }

//       if (!Array.isArray(actions)) {
//         actions = [];
//       }

//       setSelectedStaff(staff);

//       setPermissions({
//         billing: actions.includes("billing"),
//         overview: actions.includes("overview"),
//         inventory: actions.includes("inventory"),
//         reports: actions.includes("reports"),
//         addParty: actions.includes("addParty"),
//         expenses: actions.includes("expenses"),
//         barcode: actions.includes("barcode"),
//         addStaff: actions.includes("addStaff"),
//         addBranches: actions.includes("addBranches"),
//         onlineStore: actions.includes("onlineStore"),
//         premium: actions.includes("premium"),
//         loyaltyPoints: actions.includes("loyaltyPoints"),
//         addOffers: actions.includes("addOffers"),
//         settings: actions.includes("settings"),
//       });
//     }

//   } catch (error) {
//     console.log(error);
//   }
// };
// const fetchStaff = async () => {
//   try {
//     const res = await axios.get(
//       `https://api.dectwinbilling.com/fetch-staff/${clientData.id}`
//     );

//     setStaffList(res.data);
//   } catch (error) {
//     console.log(error);
//   }
// };
// useEffect(() => {
//   if (clientData?.id) {
//     fetchStaff();
//   }
// }, [clientData]);
useEffect(() => {
  if (clientData?.id) {
    fetchStaff();
    fetchRoles();
  }
}, [clientData]);
const handleSubmit = async () => {
  try {
    const selectedActions = Object.keys(permissions).filter(
      (key) => permissions[key]
    );

    const payload = {
      client_id: clientData.id,
      name: staffData.name,
      role: staffData.role,
      pass: staffData.pass,
      number: staffData.number,
      active: staffData.active === "Active" ? 0 : 1,
      actions: selectedActions,
    };

    console.log("ADD STAFF PAYLOAD:", payload);

    const res = await axios.post(
      "https://api.dectwinbilling.com/add-staff",
      payload
    );

    console.log(res.data);

    showSuccess("Staff Added Successfully");

    await fetchStaff();

    setShowPartyForm(false);

    setStaffData({
      client_id: clientData.id,
      name: "",
      role: "",
      pass: "",
      number: "",
      active: "Active",
      actions: [],
    });

    // New staff ke baad permissions reset
    setPermissions({
      billing: false,
      overview: false,
      inventory: false,
      reports: false,
      addParty: false,
      expenses: false,
      barcode: false,
      addStaff: false,
      addBranches: false,
      onlineStore: false,
      premium: false,
      loyaltyPoints: false,
      addOffers: false,
      settings: false,
    });

  } catch (err) {
    console.error(err.response?.data);

    showError(
      err.response?.data?.message ||
      err.response?.data?.error ||
      "Failed to create staff"
    );
  }
};

  return (
    <>
    {/* {showNameModal && (
  <div className="modal-overlay">
    <div className="custom-modal">
      <h3>Change Staff Name</h3>

      <div className="mt-3">
        <label>Enter Name :</label>

        <input
          type="text"
          className="form-control"
          value={newName}
          onChange={(e) =>
            setNewName(e.target.value)
          }
          placeholder="Enter Here"
        />
      </div>

      <div className="d-flex justify-content-center gap-3 mt-4">
        <button
          className="btn btn-secondary"
          onClick={() =>
            setShowNameModal(false)
          }
        >
          No
        </button>

        <button
          className="btn btn-primary"
          onClick={updateStaffName}
        >
          Yes
        </button>
      </div>
    </div>
  </div>
)} */}
{showDeleteModal && staffToDelete && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 99999,
    }}
  >
    <div
      style={{
        width: "400px",
        background: "#fff",
        borderRadius: "12px",
        padding: "25px",
        textAlign: "center",
        boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
      }}
    >
      <h4 style={{ color: "#dc3545" }}>
        Remove Staff
      </h4>

      <p style={{ marginTop: "15px" }}>
        Are you sure you want to remove
        <br />
        <strong>{staffToDelete.name}</strong>?
      </p>

      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: "20px",
        }}
      >
        <button
          onClick={() => {
            setShowDeleteModal(false);
            setStaffToDelete(null);
          }}
          style={{
            flex: 1,
            padding: "10px",
            border: "none",
            borderRadius: "8px",
            background: "#ccc",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>

        <button
          onClick={confirmDeleteStaff}
          style={{
            flex: 1,
            padding: "10px",
            border: "none",
            borderRadius: "8px",
            background: "#dc3545",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          Delete
        </button>
      </div>
    </div>
  </div>
)}
{showNameModal && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 99999,
    }}
  >
    <div
      style={{
        width: "400px",
        background: "#fff",
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
      }}
    >
     
      <h4 style={{ textAlign: "center", marginBottom: "20px" }}>
        Change Staff Name
      </h4>

  
      <input
        type="text"
        value={newName}
        onChange={(e) => setNewName(e.target.value)}
        placeholder="Enter new name"
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          outline: "none",
        }}
      />

    
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: "20px",
        }}
      >
        <button
          onClick={() => setShowNameModal(false)}
          style={{
            flex: 1,
            padding: "10px",
            borderRadius: "8px",
            border: "none",
            background: "#ccc",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>

        <button
      onClick={() => updateStaff("name")}
          style={{
            flex: 1,
            padding: "10px",
            borderRadius: "8px",
            border: "none",
            background: "#F96E5B",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          Update
        </button>
      </div>
    </div>
  </div>
)}
{showPasswordModal && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 99999,
    }}
  >
    <div
      style={{
        width: "400px",
        background: "#fff",
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
      }}
    >
      <h4 style={{ textAlign: "center", marginBottom: "20px" }}>
        Change Password
      </h4>

      <input
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        placeholder="Enter new password"
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          outline: "none",
        }}
      />

      <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
        <button
          onClick={() => setShowPasswordModal(false)}
          style={{
            flex: 1,
            padding: "10px",
            borderRadius: "8px",
            border: "none",
            background: "#ccc",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>

        <button
           onClick={() => updateStaff("password")} 
          style={{
            flex: 1,
            padding: "10px",
            borderRadius: "8px",
            border: "none",
            background: "#F96E5B",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          Update
        </button>
      </div>
    </div>
  </div>
)}
  {showRoleModal && (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999999,
      }}
    >
      <div
        style={{
          width: "350px",
          background: "#fff",
          borderRadius: "20px",
          padding: "25px",
        }}
      >
        <h3>ADD NEW ROLE</h3>

        <input
          type="text"
          className="form-control"
          value={roleName}
          onChange={(e) => setRoleName(e.target.value)}
        />

        <div className="d-flex gap-2 mt-3">
          <button
            className="btn btn-secondary"
            onClick={() => setShowRoleModal(false)}
          >
            Cancel
          </button>

        <button
  className="btn text-white"
  style={{
    background: "var(--primary-color)",
    border: "none"
  }}
  onClick={handleAddRole}
>
  Add
</button>
        </div>
      </div>
    </div>
  )}
      
      {showPartyForm && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            padding: "20px",
          }}
        >
          <div
            style={{
              background: "#fff",
              width: "100%",
              maxWidth: "900px",
              borderRadius: "15px",
              padding: "30px",
              position: "relative",
              boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <button
              onClick={() => setShowPartyForm(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "15px",
                border: "none",
                background: "none",
                fontSize: "30px",
                cursor: "pointer",
                color: "#666",
              }}
            >
              ×
            </button>

            <h2
              style={{
                textAlign: "center",
                color: "var(--primary-color)",
                fontWeight: "700",
                marginBottom: "5px",
              }}
            >
              ADD NEW STAFF
            </h2>

            <p
              style={{
                textAlign: "center",
                color: "#666",
                marginBottom: "25px",
              }}
            >
              Enter Staff Details
            </p>

            <div className="row g-4">
              <div className="col-md-6">
                <label className="form-label fw-bold">
                  Staff Name *
                </label>
             <input
  type="text"
  className="form-control"
  name="name"
  value={staffData.name}
  onChange={handleChange}
  placeholder="Enter Staff Name"
/>
                <label className="form-label fw-bold mt-3">
                  Create Password *
                </label>
             <input
  type="password"
  className="form-control"
  name="pass"
  value={staffData.pass}
  onChange={handleChange}
  placeholder="Enter Password"
/>
           <label className="form-label fw-bold mt-3">
                  Role *
                </label>
                {/* <select
  className="form-select"
  name="role"
  value={staffData.role}
  onChange={handleChange}
>
  <option value="">Select Role</option>
  <option value="Manager">Manager</option>
  <option value="Biller">Biller</option>
  <option value="Cashier">Cashier</option>
</select> */}

<select
  className="form-select"
  name="role"
  value={staffData.role}
  onChange={handleChange}
>
 
   <option value="">Select Role</option>
  <option value="Manager">Manager</option>
  <option value="Biller">Biller</option>
  <option value="Cashier">Cashier</option>

  {roles.map((role, index) => (
    <option key={index} value={role}>
      {role}
    </option>
  ))}
</select>
                <label className="form-label fw-bold mt-3">
                  Staff Number
                </label>
           <input
  type="number"
  className="form-control"
  name="number"
  value={staffData.number}
  onChange={handleChange}
  placeholder="Enter Staff Number"
/>
              </div>

              <div className="col-md-6">
                <label className="form-label fw-bold">
                  Status
                </label>
                {/* <div className="col-12 mt-4">
  <h5
    style={{
      color: "var(--primary-color)",
      fontWeight: "700",
      marginBottom: "15px",
    }}
  >
    Staff Permissions
  </h5>

  <div className="table-responsive">
    <table className="table table-bordered align-middle">
      <thead
        style={{
          background: "#F96E5B",
          color: "#fff",
        }}
      >
        <tr>
          <th>Allowed Area</th>
          <th style={{ width: "100px", textAlign: "center" }}>
            Allow
          </th>
        </tr>
      </thead>

      <tbody>
        {[
          ["Billing", "billing"],
          ["Overview", "overview"],
          ["Inventory", "inventory"],
          ["Reports", "reports"],
          ["Add Party", "addParty"],
          ["Expenses", "expenses"],
          ["Generate Barcode", "barcode"],
          ["Add Staff", "addStaff"],
          ["Add Branches", "addBranches"],
          ["My Online Store", "onlineStore"],
          ["Premium", "premium"],
          ["Loyalty Points", "loyaltyPoints"],
          ["Add Offers", "addOffers"],
          ["Settings", "settings"],
        ].map(([label, key]) => (
          <tr key={key}>
            <td>{label}</td>

            <td style={{ textAlign: "center" }}>
              <input
                type="checkbox"
                className="permission-checkbox"
                name={key}
                checked={permissions[key]}
                onChange={handlePermissionChange}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div> */}

<select
  className="form-select"
  name="active"
  value={staffData.active}
  onChange={handleChange}
>
  <option value="Active">Active</option>
  <option value="Inactive">Inactive</option>
</select>

               

               

              
              </div>
            </div>

            <div className="text-center mt-4">
               <div className="submit-area">
    <button
  className="submit-btn"
  onClick={handleSubmit}
>
  Submit Details
</button>
      </div>
            </div>
          </div>
        </div>
      )}

   
      <div
        style={{
          background: "#dfe7f0",
          minHeight: "100vh",
          padding: "20px",
        }}
      >

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "10px",
            marginBottom: "20px",
          }}
        >
          <h2
            style={{
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontWeight: "700",
            }}
          >
            <FaUsers color="#F96E5B" />
            Staff
          </h2>

          <div
            style={{
              display: "flex",
              gap: "12px",
              flexWrap: "wrap",
            }}
          >
            <button
            onClick={() => {
  setStaffData({
    client_id: clientData.id,
    name: "",
    role: "",
    pass: "",
    number: "",
    active: "Active",
    actions: [],
  });

  setPermissions({
    billing: false,
    overview: false,
    inventory: false,
    reports: false,
    addParty: false,
    expenses: false,
    barcode: false,
    addStaff: false,
    addBranches: false,
    onlineStore: false,
    premium: false,
    loyaltyPoints: false,
    addOffers: false,
    settings: false,
  });

  setSelectedStaff(null);
  setShowPartyForm(true);
}}

              // onClick={() => setShowPartyForm(true)}
              style={{
                background: "#F96E5B",
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                padding: "10px 18px",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
              }}
            >
              <FaUserPlus />
              ADD STAFF
            </button>

        <button
  onClick={() => setShowRoleModal(true)}
  style={{
    background: "#F96E5B",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    padding: "10px 18px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
  }}
>
  <IoMdSettings />
  ADD ROLE
</button>
{showRoleModalEdit && selectedStaff && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 999999,
    }}
  >
    <div
      style={{
        width: "350px",
        background: "#fff",
        borderRadius: "20px",
        padding: "25px",
        textAlign: "center",
      }}
    >
      <h3>CHANGE ROLE</h3>
{/* 
      <select
        className="form-control"
        value={newRole}
        onChange={(e) => setNewRole(e.target.value)}
      >
        {roles.map((role, i) => (
          <option key={i} value={role}>
            {role}
          </option>
        ))}
      </select> */}

      <select
  className="form-select"
  name="role"
        value={newRole}
        onChange={(e) => setNewRole(e.target.value)}
>
 
   <option value="">Select Role</option>
  <option value="Manager">Manager</option>
  <option value="Biller">Biller</option>
  <option value="Cashier">Cashier</option>

  {roles.map((role, index) => (
    <option key={index} value={role}>
      {role}
    </option>
  ))}
</select>

      <div className="d-flex justify-content-center gap-3 mt-3">
        <button
          className="btn btn-secondary"
          onClick={() => setShowRoleModalEdit(false)}
        >
          Cancel
        </button>

       <button
  className="btn text-white"
  style={{
    background: "var(--primary-color)",
    border: "none"
  }}
  onClick={() => updateStaff("role")}
>
  Update
</button>
      </div>
    </div>
  </div>
)}       </div>
        </div>

     
        <div
          style={{
            display: "grid",
       gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            gap: "20px",
          }}
        >
  
          <div
            style={{
              background: "#fff",
              borderRadius: "15px",
              minHeight: "500px",
              padding: "20px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
            }}
          >
            <h4>Staff List</h4>
            <hr />
    {/* <div className="table-responsive">
<table className="table table-hover align-middle"> */}
<div
  className="staff-table-wrapper"
  style={{
    position: "relative",
    width: "100%",
    overflow: "visible"
  }}
>
  <table className="table table-bordered table-hover staff-table">
    <thead >
      <tr    
>
        <th>S.N</th>
        <th>Name</th>
        <th>Number</th>
        <th>Role</th>
        <th>Status</th>
        <th>Activity</th>
 
      </tr>
    </thead>

    <tbody>
  {staffList.length > 0 ? (
    staffList.map((staff, index) => (
//       <tr key={staff.id}>
//         <td>{index + 1}</td>
//         <td>{staff.name}</td>
//         <td>{staff.number}</td>
//         <td>{staff.role}</td>

//         <td>
//           <span
//             className={`badge ${
//               staff.active === 0
//                 ? "bg-success"
//                 : "bg-danger"
//             }`}
//           >
//             {staff.active === 0
//               ? "Active"
//               : "Inactive"}
//           </span>
//         </td>

//         {/* <td style={{ position: "relative" }}>
//   <button
//     className="btn btn-sm btn-light"
//     onClick={() =>
//       setOpenMenu(openMenu === staff.id ? null : staff.id)
//     }
//   >
//     <FaEllipsisV />
//   </button>

//   {openMenu === staff.id && (
//     <div
//       style={{
//         position: "absolute",
//         right: 0,
//         top: "40px",
//         background: "#fff",
//         border: "1px solid #ddd",
//         borderRadius: "8px",
//         minWidth: "180px",
//         boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
//         zIndex: 999,
//       }}
//     >
// <button
//   className="dropdown-item"
//   onClick={() => toggleStaffStatus(staff)}
//   style={{
//     color: staff.active === 0 ? "#dc3545" : "#198754",
//     fontWeight: "600",
//   }}
// >
//   {staff.active === 0
//     ? "Deactivate Staff"
//     : "Activate Staff"}
// </button>
//       <button
//         className="dropdown-item"
//         onClick={() => handleEditName(staff)}
//       >
//         Change Staff Name
//       </button>

//       <button
//         className="dropdown-item"
//         onClick={() => handleChangePassword(staff)}
//       >
//         Change Password
//       </button>

//       <button
//         className="dropdown-item"
//         onClick={() => handleChangeRole(staff)}
//       >
//         Change Role
//       </button>

//    <button
//   className="dropdown-item text-danger"
//   onClick={() => handleRemoveStaff(staff)}
// >
//   Remove Staff
// </button>
//     </div>
//   )}
// </td> */}
// <td
//   className="staff-action-cell"
//   style={{
//     position: "relative",
//     overflow: "visible",
//     textAlign: "center"
//   }}
// >
//   <button
//     type="button"
//     className="staff-menu-button"
//     onClick={(e) => {
//       e.stopPropagation();
//       setOpenMenu(
//         openMenu === staff.id ? null : staff.id
//       );
//     }}
//   >
//     <FaEllipsisV />
//   </button>

//   {openMenu === staff.id && (
//     <div
//       className="staff-action-menu"
//       onClick={(e) => e.stopPropagation()}
//     >
//       <button
//         type="button"
//         onClick={() => {
//           toggleStaffStatus(staff);
//           setOpenMenu(null);
//         }}
//         style={{
//           color:
//             staff.active === 0
//               ? "#dc3545"
//               : "#198754",
//           fontWeight: "600"
//         }}
//       >
//         {staff.active === 0
//           ? "Deactivate Staff"
//           : "Activate Staff"}
//       </button>

//       <button
//         type="button"
//         onClick={() => {
//           handleEditName(staff);
//           setOpenMenu(null);
//         }}
//       >
//         Change Staff Name
//       </button>

//       <button
//         type="button"
//         onClick={() => {
//           handleChangePassword(staff);
//           setOpenMenu(null);
//         }}
//       >
//         Change Password
//       </button>

//       <button
//         type="button"
//         onClick={() => {
//           handleChangeRole(staff);
//           setOpenMenu(null);
//         }}
//       >
//         Change Role
//       </button>

//       <button
//         type="button"
//         className="staff-delete-item"
//         onClick={() => {
//           handleRemoveStaff(staff);
//           setOpenMenu(null);
//         }}
//       >
//         Remove Staff
//       </button>
//     </div>
//   )}
// </td>
//       </tr>
<tr
  key={staff.id}
  onClick={() => handleSelectStaff(staff)}
  style={{
    cursor: "pointer",
    background:
      selectedStaff?.id === staff.id
        ? "#fff1ee"
        : "transparent",
  }}
>
  <td>{index + 1}</td>

  <td>{staff.name}</td>

  <td>{staff.number}</td>

  <td>{staff.role}</td>

  <td>
    <span
      className={`badge ${
        staff.active === 0
          ? "bg-success"
          : "bg-danger"
      }`}
    >
      {staff.active === 0
        ? "Active"
        : "Inactive"}
    </span>
  </td>

  <td
    className="staff-action-cell"
    style={{
      position: "relative",
      overflow: "visible",
      textAlign: "center",
    }}
    onClick={(e) => e.stopPropagation()}
  >
    <button
      type="button"
      className="staff-menu-button"
      onClick={(e) => {
        e.stopPropagation();

        setOpenMenu(
          openMenu === staff.id
            ? null
            : staff.id
        );
      }}
    >
      <FaEllipsisV />
    </button>

    {openMenu === staff.id && (
      <div
        className="staff-action-menu"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={() => {
            toggleStaffStatus(staff);
            setOpenMenu(null);
          }}
        >
          {staff.active === 0
            ? "Deactivate Staff"
            : "Activate Staff"}
        </button>

        <button
          type="button"
          onClick={() => {
            handleEditName(staff);
            setOpenMenu(null);
          }}
        >
          Change Staff Name
        </button>

        <button
          type="button"
          onClick={() => {
            handleChangePassword(staff);
            setOpenMenu(null);
          }}
        >
          Change Password
        </button>

        <button
          type="button"
          onClick={() => {
            handleChangeRole(staff);
            setOpenMenu(null);
          }}
        >
          Change Role
        </button>

        <button
          type="button"
          className="staff-delete-item"
          onClick={() => {
            handleRemoveStaff(staff);
            setOpenMenu(null);
          }}
        >
          Remove Staff
        </button>
      </div>
    )}
  </td>
</tr>
    ))
  ) : (
    <tr>
      <td colSpan="6" className="text-center">
        No staff added yet
      </td>
    </tr>
  )}
</tbody>
  </table>
</div>
          </div>

         
         <div
  style={{
    background: "#fff",
    borderRadius: "15px",
    minHeight: "500px",
    padding: "20px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
  }}
>
  {/* <h4>Allowed Areas</h4>
  <hr /> */}

  <table className="table align-middle">
    <thead>
      <tr
        style={{
          background: "#F96E5B",
          color: "#fff",
        }}
      >
        <th>Allowed Areas</th>
        <th>Action</th>
      </tr>
    </thead>
<tbody>

  <tr>
    <td>Billing</td>
    <td>
      <input
        type="checkbox"
        className="permission-checkbox"
        name="billing"
        checked={permissions.billing}
        onChange={handlePermissionChange}
      />
    </td>
  </tr>

  <tr>
    <td>Overview</td>
    <td>
      <input
        type="checkbox"
        className="permission-checkbox"
        name="overview"
        checked={permissions.overview}
        onChange={handlePermissionChange}
      />
    </td>
  </tr>

  <tr>
    <td>Inventory</td>
    <td>
      <input
        type="checkbox"
        className="permission-checkbox"
        name="inventory"
        checked={permissions.inventory}
        onChange={handlePermissionChange}
      />
    </td>
  </tr>

  <tr>
    <td>Reports</td>
    <td>
      <input
        type="checkbox"
        className="permission-checkbox"
        name="reports"
        checked={permissions.reports}
        onChange={handlePermissionChange}
      />
    </td>
  </tr>

  <tr>
    <td>Add party</td>
    <td>
      <input
        type="checkbox"
        className="permission-checkbox"
        name="addParty"
        checked={permissions.addParty}
        onChange={handlePermissionChange}
      />
    </td>
  </tr>

  <tr>
    <td>Expenses</td>
    <td>
      <input
        type="checkbox"
        className="permission-checkbox"
        name="expenses"
        checked={permissions.expenses}
        onChange={handlePermissionChange}
      />
    </td>
  </tr>

  <tr>
    <td>Generate Barcode</td>
    <td>
      <input
        type="checkbox"
        className="permission-checkbox"
        name="barcode"
        checked={permissions.barcode}
        onChange={handlePermissionChange}
      />
    </td>
  </tr>

  <tr>
    <td>Add Staff</td>
    <td>
      <input
        type="checkbox"
        className="permission-checkbox"
        name="addStaff"
        checked={permissions.addStaff}
        onChange={handlePermissionChange}
      />
    </td>
  </tr>

  <tr>
    <td>Add Branches</td>
    <td>
      <input
        type="checkbox"
        className="permission-checkbox"
        name="addBranches"
        checked={permissions.addBranches}
        onChange={handlePermissionChange}
      />
    </td>
  </tr>

  <tr>
    <td>My online store</td>
    <td>
      <input
        type="checkbox"
        className="permission-checkbox"
        name="onlineStore"
        checked={permissions.onlineStore}
        onChange={handlePermissionChange}
      />
    </td>
  </tr>

  <tr>
    <td>Premium</td>
    <td>
      <input
        type="checkbox"
        className="permission-checkbox"
        name="premium"
        checked={permissions.premium}
        onChange={handlePermissionChange}
      />
    </td>
  </tr>

  <tr>
    <td>Loyalty points</td>
    <td>
      <input
        type="checkbox"
        className="permission-checkbox"
        name="loyaltyPoints"
        checked={permissions.loyaltyPoints}
        onChange={handlePermissionChange}
      />
    </td>
  </tr>

  <tr>
    <td>Add offers</td>
    <td>
      <input
        type="checkbox"
        className="permission-checkbox"
        name="addOffers"
        checked={permissions.addOffers}
        onChange={handlePermissionChange}
      />
    </td>
  </tr>

  <tr>
    <td>Settings</td>
    <td>
      <input
        type="checkbox"
        className="permission-checkbox"
        name="settings"
        checked={permissions.settings}
        onChange={handlePermissionChange}
      />
    </td>
  </tr>

</tbody>
    {/* <tbody>
      <tr>
        <td>Billing</td>
        <td>
<input
  type="checkbox"
  className="permission-checkbox"
  name="expenses"
  checked={permissions.expenses}
  onChange={handlePermissionChange}
/>
        </td>
      </tr>

      <tr>
        <td>Overview</td>
        <td>
        <input
          className="permission-checkbox"
  type="checkbox"
  name="barcode"
  checked={permissions.barcode}
  onChange={handlePermissionChange}
   style={{ accentColor: "#F96E5B" }}
/>
        </td>
      </tr>

      <tr>
        <td>Inventory</td>
        <td>
       <input
         className="permission-checkbox"
  type="checkbox"
  name="addStaff"
  checked={permissions.addStaff}
  onChange={handlePermissionChange}
   style={{ accentColor: "#F96E5B" }}
/>
        </td>
      </tr>

      <tr>
        <td>Reports</td>
        <td>
   <input
     className="permission-checkbox"
  type="checkbox"
  name="addBranches"
  checked={permissions.addBranches}
  onChange={handlePermissionChange}
   style={{ accentColor: "#F96E5B" }}
/>
        </td>
      </tr>

      <tr>
        <td>Add party</td>
        <td>
      <input
        className="permission-checkbox"
  type="checkbox"
  name="onlineStore"
  checked={permissions.onlineStore}
  onChange={handlePermissionChange}
   style={{ accentColor: "#F96E5B" }}
/>
        </td>
      </tr>

      <tr>
        <td>Expenses</td>
        <td>
       <input
         className="permission-checkbox"
  type="checkbox"
  name="premium"
  checked={permissions.premium}
  onChange={handlePermissionChange}
   style={{ accentColor: "#F96E5B" }}
/>
        </td>
      </tr>

      <tr>
        <td>Generate Barcode</td>
        <td>
         <input
           className="permission-checkbox"
  type="checkbox"
  name="loyaltyPoints"
  checked={permissions.loyaltyPoints}
  onChange={handlePermissionChange}
   style={{ accentColor: "#F96E5B" }}
/>
        </td>
      </tr>

      <tr>
        <td>Add Staff</td>
        <td>
        <input
          className="permission-checkbox"
  type="checkbox"
  name="addOffers"
  checked={permissions.addOffers}
  onChange={handlePermissionChange}
   style={{ accentColor: "#F96E5B" }}
/>
        </td>
      </tr>
      <tr>
        <td>Add Branches</td>
        <td>
        <input
          className="permission-checkbox"
  type="checkbox"
  name="addOffers"
  checked={permissions.addOffers}
  onChange={handlePermissionChange}
   style={{ accentColor: "#F96E5B" }}
/>
        </td>
      </tr>
      <tr>
        <td>My online store</td>
        <td>
        <input
          className="permission-checkbox"
  type="checkbox"
  name="addOffers"
  checked={permissions.addOffers}
  onChange={handlePermissionChange}
   style={{ accentColor: "#F96E5B" }}
/>
        </td>
      </tr>
      <tr>
        <td>premium</td>
        <td>
        <input
          className="permission-checkbox"
  type="checkbox"
  name="addOffers"
  checked={permissions.addOffers}
  onChange={handlePermissionChange}
   style={{ accentColor: "#F96E5B" }}
/>
        </td>
      </tr>
      <tr>
        <td>Loyality points</td>
        <td>
        <input
          className="permission-checkbox"
  type="checkbox"
  name="addOffers"
  checked={permissions.addOffers}
  onChange={handlePermissionChange}
   style={{ accentColor: "#F96E5B" }}
/>
        </td>
      </tr>
      <tr>
        <td>Add offers</td>
        <td>
        <input
          className="permission-checkbox"
  type="checkbox"
  name="addOffers"
  checked={permissions.addOffers}
  onChange={handlePermissionChange}
   style={{ accentColor: "#F96E5B" }}
/>
        </td>
      </tr>
      <tr>
        <td>Settings</td>
        <td>
        <input
          className="permission-checkbox"
  type="checkbox"
  name="addOffers"
  checked={permissions.addOffers}
  onChange={handlePermissionChange}
   style={{ accentColor: "#F96E5B" }}
/>
        </td>
      </tr>
    </tbody> */}
  </table>

  <div className="text-end mt-3">
<button
  className="btn text-white"
  style={{
    background: "#F96E5B",
    borderRadius: "25px",
    padding: "8px 20px",
    fontWeight: "600",
  }}
  onClick={handleApplyChanges}
>
  Apply Changes
</button>
  </div>
</div>
        </div>
      </div>
    </>
  );
};

export default Addstaff;